<template>
  <div>
    <b-form>
      <!-- Identificação / Tipo / Classificação (follow DFM order) -->
      <b-card class="border-0 shadow-sm rounded-lg mb-4" body-class="p-4">
        <b-row>
          <b-col md="2">
            <b-form-group label="Modelo" label-class="modal-label-premium">
              <div class="static-data-pill">{{ nfe.TX_MODELO || '55' }}</div>
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-form-group label="* Série" label-class="modal-label-premium">
              <b-form-select v-model="nfe.ID_SERIE" :options="serieOptions" :disabled="!podeEditar" class="rounded-pill shadow-xs">
                <template #first><option :value="null">Selecione</option></template>
              </b-form-select>
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-form-group label="* Número da NF-e" label-class="modal-label-premium">
              <div class="static-data-pill">{{ nfe.TX_NUM_NFE || '---' }}</div>
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-form-group label="* Data de Emissão" label-class="modal-label-premium">
              <CecInputData v-model="nfe.DT_EMISSAO" :disabled="!podeEditar" input-class="rounded-pill shadow-xs" />
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-form-group label="Data Saí/Ent" label-class="modal-label-premium">
              <b-input-group class="cec-pill-group shadow-xs">
                <CecInputData v-model="nfe.DT_SADIA_ENTRADA" :disabled="!podeEditar" input-class="cec-pill-left border-0" />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Hora Saí/Ent" label-class="modal-label-premium">
              <b-input-group class="cec-pill-group shadow-xs">
                <b-form-input type="text" v-model="nfe.TX_HORA_ENTRA_SAI" placeholder="hh:mm:ss" :disabled="!podeEditar" maxlength="8" class="cec-pill-right border-0" />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group label="* Tipo de Movimentação" label-class="modal-label-premium">
              <b-input-group>
                <b-form-input 
                  id="edTIPO_MOVIMENTACAO_ID" 
                  class="rounded-pill-left shadow-xs bg-light"
                  readonly
                  :disabled="!podeEditar"
                  :value="tipoMovDescricao"
                  placeholder="Selecione o Tipo de Movimentação"
                />
                <b-input-group-append>
                  <b-button 
                    variant="soft-primary"
                    class="rounded-pill-right shadow-xs px-3"
                    @click="abrirModalTipoMovimentacao()"
                    :disabled="!podeEditar"
                  >
                    <i class="fa fa-list"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-form-group label="CFOP" label-class="modal-label-premium">
              <div class="static-data-pill">{{ cfopDisplay || '---' }}</div>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="* Natureza da Operação" label-class="modal-label-premium">
              <div class="static-data-pill">{{ nfe.TX_NATUREZA_OPERACAO || '---' }}</div>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="4">
            <b-form-group label="* Tipo de Documento" label-class="modal-label-premium">
              <div class="static-data-pill">{{ tipoDocumentoDisplay || '---' }}</div>
            </b-form-group>
            
          </b-col>

          <b-col md="2">
            <b-form-group label="Venda N. Controle ID" label-class="modal-label-premium">
              <div class="static-data-pill">{{ nfe.ID_SEQUENCIA_VENDAS || '---' }}</div>
            </b-form-group>
            
          </b-col>

          <b-col md="2">
            <b-form-group label="* Tipo Impressão" label-class="modal-label-premium">
              <b-form-select v-model="nfe.OP_TIPO_IMPRESSAO" :options="opTipoImpressao" :disabled="!podeEditar" class="rounded-pill shadow-xs" />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="* Forma de Emissão" label-class="modal-label-premium">
              <b-form-select v-model="nfe.OP_FORMA_EMISSAO" :options="opFormaEmissao" @change="onFormaEmissaoChange" :disabled="!podeEditar" class="rounded-pill shadow-xs" />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="4">
            <b-form-group label="* Finalidade Emissão" label-class="modal-label-premium">
              <b-form-select v-model="nfe.OP_FINALIDADE_EMISSAO" :options="opFinalidadeEmissao" @change="onFinalidadeChange" :disabled="!podeEditar" class="rounded-pill shadow-xs" />
            </b-form-group>
          </b-col>
        
          <b-col md="4">
            <b-form-group label="* Destino Operação" label-class="modal-label-premium">
              <b-form-select v-model="nfe.OP_DESTINO_OPERACAO" :options="opDestinoOperacao" :disabled="!podeEditar" class="rounded-pill shadow-xs" />
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-form-group label="* Consumidor Final" label-class="modal-label-premium">
              <b-form-select v-model="nfe.OP_CONSUMIDOR_FINAL" :options="opConsumidorFinal" :disabled="!podeEditar" class="rounded-pill shadow-xs" />
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-form-group label="* Tipo de Atendimento" label-class="modal-label-premium">
              <b-form-select v-model="nfe.OP_TIPO_ATENDIMENTO" :options="opTipoAtendimento" :disabled="!podeEditar" class="rounded-pill shadow-xs" />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>

      <!-- Digest / Protocolo / Totais (as in DFM) -->
      <b-card class="border-0 shadow-sm rounded-lg mb-4" body-class="p-4">
        <b-row>
          <b-col md="6">
            <b-form-group label="Chave de Acesso" label-class="modal-label-premium">
              <div class="static-data-pill mono-value">{{ nfe.TX_CHAVE_ACESSO || '---' }}</div>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label="Compra Gado" label-class="modal-label-premium">
              <div class="static-data-pill">{{ nfe.LOTE_COMPRA_GADO || '---' }}</div>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label="Peso Líq / Bruto" label-class="modal-label-premium">
              <div class="d-flex">
                <div class="static-data-pill mr-1 text-center" style="flex: 1;">{{ nfe.NR_PESO_LIQUIDO || '0,00' }}</div>
                <div class="static-data-pill ml-1 text-center" style="flex: 1;">{{ nfe.NR_PESO_BRUTO || '0,00' }}</div>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="3">
            <b-form-group label="Digest Value da NF-e" label-class="modal-label-premium">
              <div class="static-data-pill mono-value">{{ nfe.TX_NUM_DIGEST_VALUE || '---' }}</div>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label="Usuário Cadastro" label-class="modal-label-premium">
              <div class="static-data-pill">{{ nfe.TX_USUARIO_CADASTRO || '---' }}</div>
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-form-group label="Data Cadastro" label-class="modal-label-premium">
              <div class="static-data-pill text-center">{{ dataCadastroDisplay }}</div>
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-form-group label="Protocolo" label-class="modal-label-premium">
              <div class="static-data-pill">{{ nfe.TX_NUM_PROTOCOLO || '---' }}</div>
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-form-group label="Data Protocolo" label-class="modal-label-premium">
              <div class="static-data-pill text-center">{{ dataProtocoloDisplay }}</div>
            </b-form-group>
          </b-col>
        </b-row>

        
      </b-card>
    </b-form>

    <!-- Modal Tipo de Movimentação -->
    <b-modal 
      ref="modal-tipo-movimentacao" 
      id="modal-tipo-movimentacao" 
      size="xl"
      hide-footer
      hide-header
      body-class="p-0 overflow-hidden"
      content-class="border-0 shadow-lg"
    >
      <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #20a8d8 0%, #1783ae 100%) !important;">
        <div class="header-icon-wrapper mr-3 bg-white-10">
          <i class="fa fa-list text-white"></i>
        </div>
        <div>
          <h5 class="mb-0 font-weight-bold text-white">Tipo de Movimentação</h5>
          <small class="text-white opacity-75">Selecione a operação desejada para a nota fiscal</small>
        </div>
        <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="$refs['modal-tipo-movimentacao'].hide()">
          <i class="fa fa-times fa-lg"></i>
        </b-button>
      </div>

      <div class="p-4 bg-white">
        <div class="modal-info-bar mb-4 p-3 bg-light rounded border shadow-sm">
          <b-row align-v="center">
            <b-col md="12">
              <div class="d-flex align-items-center">
                <i class="fa fa-search mr-3 text-muted"></i>
                <b-form-input
                  id="filtro-tipo-mov"
                  v-model="modalTipoMovimentacao.filtro"
                  type="text"
                  placeholder="Pesquisar por código ou descrição da operação..."
                  class="rounded-pill border-0 shadow-none bg-transparent"
                  style="font-size: 1.1rem;"
                />
              </div>
            </b-col>
          </b-row>
        </div>
        
        <div class="rounded border shadow-sm overflow-hidden">
          <b-table
            striped
            hover
            :sticky-header="true"
            :small="true"
            :items="tipoMovimentacaoItemsFiltrados"
            :fields="modalTipoMovimentacao.fields"
            select-mode="single"
            selectable
            @row-selected="selecionarTipoMovimentacao"
            show-empty
            empty-text="Nenhum tipo de movimentação encontrado"
            class="mb-0"
            style="max-height: 400px;"
          >
          </b-table>
        </div>
      </div>

      <div class="modal-footer-premium p-3 bg-light border-top text-right">
        <b-button variant="soft-danger" pill class="px-5 font-weight-bold" @click="$refs['modal-tipo-movimentacao'].hide()">
          FECHAR
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CecInputData from '@/components/Cec/CecInputData.vue'

export default {
  name: 'NfeAbaDados',
  components: {
    CecInputData
  },
  props: {
    nfe: { type: Object, required: true },
    isLoadingFromBackend: { type: Boolean, default: false },
    podeEditar: { type: Boolean, default: false }
  },
  data() {
    return {
      tipoMovimentacoes: { items: [], options: [] },
      tipoMovMap: new Map(),
      serieOptions: [],
      tipoMovDescricao: '',
      modalTipoMovimentacao: {
        filtro: '',
        fields: [
          { key: 'ID', label: 'ID', sortable: true },
          { key: 'DESCRICAO', label: 'Descrição', sortable: true },
          { key: 'TRADUCAO', label: 'Nome Amigável', sortable: true }
        ]
      },
      // options copied directly from the Delphi DFM (origem: contexto/units delphi/Unt_NotaFiscalEletronica.dfm)
      opTipoDocumento: [
        { value: '0', text: '0 - Entrada' },
        { value: '1', text: '1 - Saída' }
      ],
      opTipoImpressao: [
        { value: '1', text: '1 - Retrato' },
        { value: '2', text: '2 - Paisagem' }
      ],
      opFormaEmissao: [
        // NOTE: DFM had Description '1 - Normal' with Value '0' (kept exact mapping)
        { value: '0', text: '0 - Normal' },
        { value: '1', text: '1 - Contingência FS – emissão em contingência com impressão do DANFE em Formulário de Segurança' }
      ],
      opFinalidadeEmissao: [
        { value: '1', text: '1 - NF-e normal' },
        { value: '2', text: '2 - NF-e complementar' },
        { value: '3', text: '3 - NF-e de ajuste' },
        { value: '4', text: '4 - Devolução de Mercadoria' }
      ],
      opConsumidorFinal: [
        { value: '0', text: '0 - Não' },
        { value: '1', text: '1 - Sim' }
      ],
      opTipoAtendimento: [
        { value: '0', text: '0 - Não se Aplica' },
        { value: '1', text: '1 - Operação Presencial' },
        { value: '2', text: '2 - Operação NÃO Presencial, Pela Internet' },
        { value: '3', text: '2 - Operação NÃO Presencial, Pelo Atendimento' },
        { value: '9', text: '4 - Operação NÃO Presencial, Outros' }
      ],
      opDestinoOperacao: [
        { value: '1', text: '1 - Operação Interna' },
        { value: '2', text: '2 - Operação Interestadual' },
        { value: '3', text: '3 - Operação com o Exterior' }
      ]
    }
  },
  watch: {
    'nfe.ID_EMPRESA': {
      handler(newVal) {
        if (newVal) {
          this.carregarSeries()
        }
      },
      immediate: true
    },
    'nfe.TIPO_MOVIMENTACAO_ID': {
      handler(newVal) {
        this.atualizarDescricaoTipoMov(newVal)
      },
      immediate: true
    }
  },
  computed: {
    cfopDisplay() {
      const cfopId = this.nfe.CFOP_ID
      if (!cfopId && cfopId !== 0) return ''
      return String(cfopId)
    },
    tipoDocumentoDisplay() {
      const doc = this.nfe.OP_TIPO_DOCUMENTO
      if (doc === null || doc === undefined || doc === '') return ''
      const opt = this.opTipoDocumento.find(o => String(o.value) === String(doc))
      return opt ? opt.text : String(doc)
    },
    destinoOperacaoDisplay() {
      const dest = this.nfe.OP_DESTINO_OPERACAO
      if (dest === null || dest === undefined || dest === '') return ''
      const opt = this.opDestinoOperacao.find(o => String(o.value) === String(dest))
      return opt ? opt.text : String(dest)
    },
    tipoMovimentacaoItemsFiltrados() {
      if (!this.modalTipoMovimentacao.filtro) {
        return this.tipoMovimentacoes.items
      }
      const f = this.modalTipoMovimentacao.filtro.toLowerCase()
      return this.tipoMovimentacoes.items.filter(i => 
        String(i.ID).toLowerCase().includes(f) || 
        String(i.DESCRICAO || '').toLowerCase().includes(f) ||
        String(i.TRADUCAO || '').toLowerCase().includes(f)
      )
    },
    dataCadastroDisplay() {
      if (!this.nfe.DT_CADASTRO) return '---'
      try {
        const d = new Date(this.nfe.DT_CADASTRO)
        return isNaN(d.getTime()) ? this.nfe.DT_CADASTRO : d.toLocaleDateString('pt-BR')
      } catch (e) {
        return this.nfe.DT_CADASTRO
      }
    },
    dataProtocoloDisplay() {
      if (!this.nfe.DT_PROTOCOLO_NFE) return '---'
      try {
        const d = new Date(this.nfe.DT_PROTOCOLO_NFE)
        return isNaN(d.getTime()) ? this.nfe.DT_PROTOCOLO_NFE : d.toLocaleDateString('pt-BR')
      } catch (e) {
        return this.nfe.DT_PROTOCOLO_NFE
      }
    }
  },
  created() {
    this.carregarTipoMovimentacoes()
    this.carregarSeries()
  },
  mounted() {
    // origem: contexto/units delphi/Unt_NotaFiscalEletronica.pas: FormShow / FormCreate
    // Keep this mounted hook for any initialization that the Delphi form did.
  },
  methods: {
    async carregarTipoMovimentacoes() {
      try {
        const { data } = await this.$http.get(`/api/protected/tipoMovimentacao/listar`)
        const lista = Array.isArray(data) ? data : []

        this.tipoMovimentacoes.items = lista
        this.tipoMovimentacoes.options = lista.map(t => ({
          value: t.ID,
          text: t.TRADUCAO || `${t.ID} - ${t.DESCRICAO}`
        }))

        this.tipoMovMap.clear()
        for (const t of lista) this.tipoMovMap.set(String(t.ID), t)

        // Atualizar descrição após carregar os itens
        if (this.nfe.TIPO_MOVIMENTACAO_ID) {
          this.atualizarDescricaoTipoMov(this.nfe.TIPO_MOVIMENTACAO_ID)
        }
      } catch (err) {
        console.error('Erro ao carregar tipos de movimentação:', err)
      }
    },

    atualizarDescricaoTipoMov(id) {
      if (!id && id !== 0) {
        this.tipoMovDescricao = ''
        return
      }
      
      const mov = (this.tipoMovimentacoes.items || []).find(t => String(t.ID) === String(id))
      if (mov) {
        this.tipoMovDescricao = mov.TRADUCAO || `${mov.ID} - ${mov.DESCRICAO}`
      } else {
        this.tipoMovDescricao = String(id)
      }
    },

    async carregarSeries() {
      try {
        // Buscar empresaId do nfe ou do store/session
        const empresaId = this.nfe.ID_EMPRESA || this.$store.state.empresaId || 1
        if (!empresaId) return
        
        const { data } = await this.$http.get(`/api/protected/notaFiscal/getSerie/${empresaId}`)
        const lista = Array.isArray(data) ? data : []

        // O backend salva ID_SERIE com o valor de SERIE (string como "1", "2", etc)
        // Portanto, mapeamos SERIE como value e SERIE como text para exibição
        this.serieOptions = lista.map(s => ({
          value: String(s.SERIE),
          text: `${s.SERIE}`
        }))
      } catch (err) {
        console.error('Erro ao carregar séries:', err)
        // Em caso de erro, permitir entrada manual
        this.serieOptions = []
      }
    },

    abrirModalTipoMovimentacao() {
      if (!this.podeEditar) return
      this.modalTipoMovimentacao.filtro = ''
      this.$refs['modal-tipo-movimentacao'].show()
      this.$nextTick(() => {
        const input = document.getElementById('filtro-tipo-mov')
        if (input) input.focus()
      })
    },

    async selecionarTipoMovimentacao(items) {
      if (items && items.length > 0) {
        const item = items[0]
        this.nfe.TIPO_MOVIMENTACAO_ID = item.ID
        this.tipoMovDescricao = item.TRADUCAO || `${item.ID} - ${item.DESCRICAO}`
        this.$refs['modal-tipo-movimentacao'].hide()
        await this.onTipoMovChange(item.ID)
        this.$emit('tipo-movimentacao-alterada', item.ID)
      }
    },

    async onTipoMovChange(novoValor) {
      // IGNORAR eventos durante carregamento do backend
      if (this.isLoadingFromBackend) {
        return
      }
      
      const tipoMovId = novoValor || this.nfe.TIPO_MOVIMENTACAO_ID
      const mov = this.tipoMovMap.get(String(tipoMovId))
      if (!mov) return

      const updates = {}

      // Auto-preencher campos baseado no tipo de movimentação
      if (mov.CFOP_ID != null) {
        updates.CFOP_ID = String(mov.CFOP_ID)
      }

      if (mov.DESCRICAO) {
        updates.TX_NATUREZA_OPERACAO = mov.DESCRICAO
      }

      if (mov.OP_TIPO_MOVIMENTACAO != null && mov.OP_TIPO_MOVIMENTACAO !== '') {
        updates.OP_TIPO_DOCUMENTO = String(mov.OP_TIPO_MOVIMENTACAO).toUpperCase().trim() === 'S' ? '1' : '0'
      } else if (mov.FORMA) {
        const forma = String(mov.FORMA).toUpperCase().trim()
        let tipoDoc = '1' // Default: Saída
        
        if (forma === 'COMPRA' || forma.includes('COMPRA') || forma.includes('ENTRADA')) {
          tipoDoc = '0' // Entrada
        } else if (forma === 'VENDA' || forma === 'TROCA' || forma === 'TRANSFERENCIA' || 
                   forma.includes('VENDA') || forma.includes('SAIDA') || forma === 'OUTROS') {
          tipoDoc = '1' // Saída
        }
        updates.OP_TIPO_DOCUMENTO = tipoDoc
      }

      if (mov.OP_DESTINO_OPERACAO != null) {
        updates.OP_DESTINO_OPERACAO = String(mov.OP_DESTINO_OPERACAO)
      }

      if (mov.OP_FINALIDADE_EMISSAO != null && mov.OP_FINALIDADE_EMISSAO !== '') {
        updates.OP_FINALIDADE_EMISSAO = String(mov.OP_FINALIDADE_EMISSAO)
      }

      // Buscar e preencher texto do tipo de movimentação (OBS_OUTROS)
      if (mov.TEXTO_NFE_ID) {
        try {
          const { data } = await this.$http.get(`/api/protected/notaFiscal/texto/getById/${mov.TEXTO_NFE_ID}`)
          const textoNfe = Array.isArray(data) ? data[0] : data
          if (textoNfe && textoNfe.TEXTO) {
            updates.OBS_OUTROS = textoNfe.TEXTO
          }
        } catch (err) {
          console.error('Erro ao buscar texto NFe:', err)
        }
      } else {
        // Se não houver TEXTO_NFE_ID, limpar o campo OBS_OUTROS
        updates.OBS_OUTROS = ''
      }

      // Aplicar todas as atualizações
      Object.keys(updates).forEach(key => {
        this.$set(this.nfe, key, updates[key])
      })

      this.$forceUpdate()
    },

    onCFOPLookup() {
      // origem: contexto/units delphi/Unt_NotaFiscalEletronica.dfm: comboCFOP_ID.Properties.OnButtonClick = comboCFOP_IDPropertiesButtonClick
      // TODO: implement CFOP lookup dialog and set nfe.CFOP_ID
      this.$emit('open-cfop-lookup')
    },
    onFinalidadeChange() {
      // origem: contexto/units delphi/Unt_NotaFiscalEletronica.dfm: ComboOP_FINALIDADE_EMISSAO.OnExit = ComboOP_FINALIDADE_EMISSAOExit
      // TODO: translate Delphi ComboOP_FINALIDADE_EMISSAOExit logic from .pas to JS and run it here
      // Placeholder: emit an event so parent can handle rules or adjust fields
      this.$emit('finalidade-changed', this.nfe.OP_FINALIDADE_EMISSAO)
    },
    onFormaEmissaoChange() {
      // origem: contexto/units delphi/Unt_NotaFiscalEletronica.pas: various references to OP_FORMA_EMISSAO
      // TODO: apply any business rules that Delphi applied when forma de emissao changes
      this.$emit('forma-emissao-changed', this.nfe.OP_FORMA_EMISSAO)
    }
  }
}
</script>

<style scoped>
.modal-header-premium {
    border-bottom: none;
}

.header-icon-wrapper {
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    font-size: 1.2rem;
}

.bg-white-10 {
    background-color: rgba(255, 255, 255, 0.15) !important;
}

.modal-section-title {
    font-size: 0.85rem;
    font-weight: 700;
    color: #2d3748;
    border-bottom: 2px solid #edf2f7;
    padding-bottom: 0.5rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.modal-label-premium {
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #6c757d;
    margin-bottom: 0.4rem;
    display: block;
}

.shadow-xs {
    box-shadow: 0 2px 4px rgba(0,0,0,0.05) !important;
}

.btn-soft-danger {
    background-color: rgba(248, 108, 107, 0.1);
    color: #f86c6b;
    border: none;
}
.btn-soft-danger:hover {
    background-color: #f86c6b;
    color: white;
}

.btn-soft-primary {
    background-color: rgba(32, 168, 216, 0.1);
    color: #20a8d8;
    border: none;
}
.btn-soft-primary:hover {
    background-color: #20a8d8;
    color: white;
}

.rounded-pill-left {
  border-top-left-radius: 50rem !important;
  border-bottom-left-radius: 50rem !important;
}

.rounded-pill-right {
  border-top-right-radius: 50rem !important;
  border-bottom-right-radius: 50rem !important;
}

.cec-pill-left {
  border-top-left-radius: 50rem !important;
  border-bottom-left-radius: 50rem !important;
}

.cec-pill-right {
  border-top-right-radius: 50rem !important;
  border-bottom-right-radius: 50rem !important;
}

input[type="date"].vazio:not(:focus)::-webkit-datetime-edit {
  color: transparent;
  caret-color: transparent;
}

.static-data-value {
  display: flex;
  align-items: center;
  min-height: 38px;
  font-weight: 600;
  color: #2d3748;
  font-size: 0.95rem;
  padding: 0 0.5rem;
}

.static-data-pill {
    background-color: #f8fafc;
    padding: 0.4rem 0.75rem;
    border-radius: 50rem;
    font-weight: 600;
    color: #4a5568;
    font-size: 0.85rem;
    display: flex;
    align-items: center;
    width: 100%;
    border: 1px solid #edf2f7;
    min-height: 38px;
    box-shadow: inset 0 1px 2px rgba(0,0,0,0.02);
}

.mono-value {
    font-family: 'Courier New', Courier, monospace;
    font-size: 0.85rem;
    letter-spacing: 0.5px;
}
</style>



// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/NfeAbaDados.vue